import { Content } from '@angular/compiler/src/render3/r3_ast';
import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../services/content.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  footerRow: any = null;
  constructor(private contentService: ContentService) { }

  ngOnInit(): void {
    this.footerRow = this.contentService.getFooterRow();
  }

}
